class SveaController extends AbstractIntegrationController
	@register()
	@inject 'configuration', 'Shops'

	integrationId: 'svea'

	initialize: ->
		@shops = @Shops.data

		if Array.isArray(@configuration.shops)
			@configuration.shops = {}

	save: ->
		for id, shop of @configuration.shops
			if (shop.instore_secret == '')
				delete shop.instore_secret

			if (shop.payment_admin_secret == '')
				delete shop.payment_admin_secret

		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
